<template>
  <b-form @submit.prevent="submitForm" ref="form" :validated="validated" v-if="validId" novalidate>
    <fieldset>
      <SignupLegend title="Please enter your new password"/>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Password</label>
        <div class="col-sm-9">
          <input type="password" class="form-control" placeholder="password" minlength="9" v-model="password" required>
          <div class="invalid-feedback">Password with at least 9 characters is required.</div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-12">
          <button type="submit" class="btn btn-primary float-right">
            <span class="fas fa-lock"></span> Set new password
          </button>
        </div>
      </div>
    </fieldset>
  </b-form>
</template>

<script>
  import EventBus from '@/utils/EventBus'
  import SignupLegend from '@/components/SignupLegend'
  import api from '@/utils/api'

  export default {
    components: {
      SignupLegend
    },
    data () {
      return {
        password: '',
        uniqueId: '',
        validated: false,
        validId: false
      }
    },
    methods: {
      async submitForm () {
        EventBus.$emit('hide-notification')
        this.validated = true
        if (this.$refs.form.checkValidity()) {
          await api.postResetPassword(this.password, this.uniqueId)
          this.password = ''
          this.validated = false
          this.validId = false
          EventBus.$emit('show-notification', 'success', 'Your password has been set successfully.')
        }
      }
    },
    async mounted () {
      this.$emit('set-title', 'Reset your password')
      this.uniqueId = Object.keys(this.$route.query)[0]
      await api.checkUserIdForResetPassword(this.uniqueId)
      this.validId = true
    }
  }
</script>

<style lang="scss" scoped>
</style>
